import { useState } from 'react';

const testimonials = [
  {
    quote:
      'DAS Cleaning transformed our 15,000 sq ft headquarters. The team is professional, thorough, and always on time. Our employees have noticed a significant improvement in workplace cleanliness and morale.',
    name: 'Sarah Mitchell',
    title: 'VP of Operations',
    company: 'Nexus Financial Group',
    avatar:
      'https://public.readdy.ai/ai/img_res/955346222d756d6862ec4158a5b45cc5.jpg',
    rating: 5,
  },
  {
    quote:
      'We switched to DAS Cleaning after struggling with inconsistent service from our previous provider. The difference was immediate — spotless offices every morning, and a dedicated account manager who actually responds.',
    name: 'James Thornton',
    title: 'Facilities Director',
    company: 'Meridian Tech Solutions',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20businessman%20headshot%2C%20confident%20smile%2C%20corporate%20attire%2C%20neutral%20background%2C%20high%20quality%20portrait%20photo%2C%20natural%20lighting%2C%20professional%20look&width=80&height=80&seq=ava002&orientation=squarish',
    rating: 5,
  },
  {
    quote:
      'As a healthcare facility, our hygiene standards are non-negotiable. DAS Cleaning\'s certified team meets every requirement and their hospital-grade protocols give us complete peace of mind.',
    name: 'Dr. Linda Okafor',
    title: 'Chief Medical Officer',
    company: 'ClearPath Medical Center',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20female%20doctor%20headshot%2C%20confident%20smile%2C%20medical%20attire%2C%20neutral%20background%2C%20high%20quality%20portrait%20photo%2C%20natural%20lighting%2C%20professional%20look&width=80&height=80&seq=ava003&orientation=squarish',
    rating: 5,
  },
  {
    quote:
      'The eco-friendly cleaning program was exactly what we needed for our LEED-certified building. DAS Cleaning delivered on every promise — sustainable products, zero disruption, and exceptional results.',
    name: 'Marcus Chen',
    title: 'Sustainability Manager',
    company: 'GreenBridge Capital',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20headshot%2C%20confident%20smile%2C%20corporate%20attire%2C%20neutral%20background%2C%20high%20quality%20portrait%20photo%2C%20natural%20lighting%2C%20professional%20look&width=80&height=80&seq=ava004&orientation=squarish',
    rating: 5,
  },
  {
    quote:
      'Our retail showrooms need to look perfect every single day. DAS Cleaning\'s after-hours team ensures our floors are gleaming and displays are spotless before we open. Absolutely reliable.',
    name: 'Priya Sharma',
    title: 'Regional Store Manager',
    company: 'Luxe Interiors Co.',
    avatar:
      'https://readdy.ai/api/search-image?query=professional%20indian%20businesswoman%20headshot%2C%20confident%20smile%2C%20corporate%20attire%2C%20neutral%20background%2C%20high%20quality%20portrait%20photo%2C%20natural%20lighting%2C%20professional%20look&width=80&height=80&seq=ava005&orientation=squarish',
    rating: 5,
  },
];

const logos = [
  'Nexus Financial', 'Meridian Tech', 'ClearPath Medical', 'GreenBridge Capital', 'Luxe Interiors', 'Apex Logistics',
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));

  const t = testimonials[current];

  return (
    <section id="testimonials" className="py-20 md:py-28 bg-[#1a3a2a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <span
            className="text-[#4caf7d] text-xs font-semibold tracking-widest uppercase"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Client Stories
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold text-white mt-2"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            What Our Clients Say
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-3xl mx-auto">
          <div className="relative bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12">
            {/* Rating */}
            <div className="flex gap-1 mb-6">
              {Array.from({ length: t.rating }).map((_, i) => (
                <i key={i} className="ri-star-fill text-[#f5a623] text-sm"></i>
              ))}
            </div>

            {/* Quote */}
            <blockquote
              className="text-white/90 text-lg md:text-xl leading-relaxed mb-8"
              style={{ fontFamily: "'Lora', serif" }}
            >
              &ldquo;{t.quote}&rdquo;
            </blockquote>

            {/* Author */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <div className="text-white font-semibold text-sm" style={{ fontFamily: "'Syne', sans-serif" }}>
                  {t.name}
                </div>
                <div className="text-white/50 text-xs mt-0.5">
                  {t.title} · {t.company}
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center justify-between mt-8 pt-6 border-t border-white/10">
              <div className="flex gap-2">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setCurrent(i)}
                    className={`w-2 h-2 rounded-full transition-all duration-200 cursor-pointer ${
                      i === current ? 'bg-[#4caf7d] w-6' : 'bg-white/20'
                    }`}
                  />
                ))}
              </div>
              <div className="flex gap-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white hover:bg-white/10 transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-arrow-left-line text-sm"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center bg-[#4caf7d] rounded-full text-white hover:bg-[#3d9e6e] transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Client Logos */}
        <div className="mt-16 pt-10 border-t border-white/10">
          <p className="text-center text-white/30 text-xs uppercase tracking-widest mb-8">
            Trusted by leading companies
          </p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-10">
            {logos.map((logo) => (
              <div
                key={logo}
                className="text-white/25 text-sm font-semibold tracking-wide"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                {logo}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
